import React from 'react';
import styles from './exercise-states.module.css.js';
import styles$1 from './exercise-loading.module.css.js';
import img from '../../../assets/images/spinner.svg.js';

const ExerciseLoading = ({ children }) => {
    return (React.createElement("div", { className: styles.overlay },
        React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.icon },
                React.createElement("i", { className: 'bc-icon bc-icon-exercise-fill', role: 'img' })),
            React.createElement("div", { className: styles.message },
                React.createElement("p", null, children)),
            React.createElement("img", { src: img, alt: 'spinner', className: styles$1.spinner }))));
};

export { ExerciseLoading };
